import { useUserInfo } from '../utils/permissions';
import { ROLE } from '../utils/permissions';

const agileAppName = 'Fast & MK2';

export const useProviderRbac = () => {
  const { userInfo } = useUserInfo();

  const isProviderInventoryManager =
    userInfo?.roleAssociations?.filter((role) => role.application === agileAppName)[0]?.code ===
      ROLE.BASIC_PROVIDER ||
    userInfo?.roleAssociations?.filter((role) => role.application === agileAppName)[0]?.code ===
      ROLE.ADVANCED_PROVIDER;

  const providerNameRbac =
    userInfo?.roleAssociations
      ?.filter(
        (role) =>
          role.application === agileAppName &&
          (role.code === ROLE.BASIC_PROVIDER || role.code === ROLE.ADVANCED_PROVIDER),
      )[0]
      ?.tags?.filter((tag) => tag.tagType === 'provider')[0]?.name || '';

  return { providerNameRbac, isProviderInventoryManager };
};
